/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Account(props) {
    return (
        <SvgIcon {...props}>
            <path d="M2.3 29c.4-5 4.7-9 10-9h7.5c5.3 0 9.6 4 10 9h-2c-.4-4-3.8-7-8-7h-7.5c-4.2 0-7.6 3-8 7h-2zm20.9-18.9c0-4.1-3.3-7.4-7.4-7.4-4.1 0-7.4 3.3-7.4 7.4 0 4.1 3.3 7.4 7.4 7.4 4.1 0 7.4-3.3 7.4-7.4zm-2 0c0 3-2.4 5.4-5.4 5.4-3 0-5.4-2.4-5.4-5.4s2.4-5.4 5.4-5.4c3 0 5.4 2.4 5.4 5.4z" />
        </SvgIcon>
    );
}

Account.defaultProps = {
    viewBox: '0 0 32 32'
};

export default Account;
